import React from 'react';
import { CardBody, CardFeatured, CardFooter, CardTitle } from '@/components/card';
import Link from '@/providers/Link';
import { Button } from '@/components/button';
import { urlOfertas } from '@/utils/browser';
import CardMedia from '@/components/card/CardMedia/CardMedia';
import { useTranslations } from 'next-intl';

type CardOfferProps = {
  offer: CardOfferType;
};

const CardOffer = ({ offer }: CardOfferProps) => {
  const t = useTranslations('Oferta');
  return (
    <CardFeatured key={offer.slug}>
      <CardMedia media={offer.media} href={urlOfertas(offer.slug)} mediaOptions={{ featured: true }} />
      <CardTitle as="h2">
        <Link href={urlOfertas(offer.slug)}>{offer.title}</Link>
      </CardTitle>
      <CardBody>{offer.summary}</CardBody>
      <CardFooter>
        <Button href={urlOfertas(offer.slug)} block>
          {t('Mais Detalhes')}
        </Button>
      </CardFooter>
    </CardFeatured>
  );
};

export default CardOffer;
